import {
  TbList,
  TbListSearch,
  TbSearch,
  TbPuzzle,
  TbPlus,
  TbFilePencil,
  TbX,
} from 'react-icons/tb'
import { collectionSupportsOperation } from './collections'
import { CollectionOperationsType, IntegrationCollectionType } from './types'

export const collectionOperations: CollectionOperationsType[] = [
  {
    key: 'list',
    name: 'List',
    check: (collection: IntegrationCollectionType) =>
      collectionSupportsOperation(collection, 'list'),
    Icon: TbList,
  },
  {
    key: 'findById',
    name: 'Find by Id',
    check: (collection: IntegrationCollectionType) =>
      collectionSupportsOperation(collection, 'findById'),
    Icon: TbListSearch,
  },
  {
    key: 'search',
    name: 'Search',
    check: (collection: IntegrationCollectionType) =>
      collectionSupportsOperation(collection, 'search'),
    Icon: TbSearch,
  },
  {
    key: 'match',
    name: 'Match',
    check: (collection: IntegrationCollectionType) =>
      collectionSupportsOperation(collection, 'match'),
    Icon: TbPuzzle,
  },
  {
    key: 'create',
    name: 'Create',
    check: (collection: IntegrationCollectionType) =>
      collectionSupportsOperation(collection, 'create'),
    Icon: TbPlus,
  },
  {
    key: 'update',
    name: 'Update',
    check: (collection: IntegrationCollectionType) =>
      collectionSupportsOperation(collection, 'update'),
    Icon: TbFilePencil,
  },
  {
    key: 'delete',
    name: 'Delete',
    check: (collection: IntegrationCollectionType) =>
      collectionSupportsOperation(collection, 'delete'),
    Icon: TbX,
  },
]
